export function scoreFormat(score){
    if(!score || isNaN(score)) return 0
    const numScore = Number(score);
    if(isNaN(numScore)) return 0
    if(numScore >= numScore.toPrecision(3)) {
        if(numScore % 1 === 0) return numScore.toString()
        return numScore.toFixed(2).toString()
    }   
    return numScore.toPrecision(3)
}